import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaHome, FaSignOutAlt, FaFileAlt } from 'react-icons/fa';

const AdminEnquiry = () => {
    const [logout, setLogout] = useState(false);
    const [enquiry, setEnquiry] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');

    const handleLogout = () => {
        localStorage.removeItem('isLoggedIn');
        navigate('/admin-login');
        window.location.reload();
    }

    useEffect(() => {
        fetchEnquiry();
    }, []);

    const fetchEnquiry = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://api.siddhabhairabistore.com/surbhi/get-enquiry');
            if (response.ok) {
                const data = await response.json();
                // Map to data.result, which is the array
                setEnquiry(data.result || []);
            } else {
                console.error('Failed to fetch enquiry');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    const filteredData = enquiry.filter(itm =>
        Object.values(itm).some(val =>
            String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
    )

    return (
        <>
            {/* Sidebar */}
            <div className='sidebar-left shadow-lg'>
                <span className='sidebar-icon tooltip-item' onClick={() => navigate('/dashboard')}>
                    <FaHome size={22} />
                    <span className='tooltip-text'>Dashboard</span>
                </span>
                <span className='sidebar-icon tooltip-item' onClick={() => navigate('/enquiry')}>
                    <FaFileAlt size={22} />
                    <span className='tooltip-text'>Enquiry</span>
                </span>
                <span className='sidebar-icon tooltip-item' onClick={() => setLogout(true)}>
                    <FaSignOutAlt size={22} className='text-danger' />
                    <span className='tooltip-text'>Logout</span>
                </span>
            </div>

            {/* Content */}
            <div className='sidebar-right'>
                <div className='sidebar-right-inner'>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                        <h3 className='fw-bold mb-4'>All Enquiries</h3>
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="search-input"
                        />
                    </div>
                    {loading ? (
                        <p>Loading...</p>
                    ) : (
                        <div className='table-responsive'>
                            <table className='w-100 table table-striped'>
                                <thead className='bg-dark text-light'>
                                    <tr>
                                        <th className='px-2 py-2 rounded-start'>Name</th>
                                        <th className='px-2 py-2'>Loan Type</th>
                                        <th className='px-2 py-2'>Mobile</th>
                                        <th className='px-2 py-2 rounded-end'>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.map(enq => (
                                        <tr key={enq.id}>
                                            <td className='px-2 py-2'>{enq.name}</td>
                                            <td className='px-2 py-2'>{enq.loanType}</td>
                                            <td className='px-2 py-2'>{enq.phone}</td>
                                            <td className='px-2 py-2'>{enq.description}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>

            {/* Logout Modal */}
            {logout && (
                <div className="dialog-outer">
                    <div className="dialog-inner text-center">
                        <p className="fs-5 fw-bold text-danger mb-4">Logout Admin?</p>
                        <button className="btn btn-danger px-4 py-2 me-3" onClick={handleLogout}>Yes</button>
                        <button className="btn btn-secondary px-4 py-2" onClick={() => setLogout(false)}>No</button>
                    </div>
                </div>
            )}
        </>
    );
}

export default AdminEnquiry;
